module.exports = __webpack_public_path__ + "static/media/wor_clo_to_wat_sit_spe_met.db00aa17.png";